import {isOnServer} from '@gfiber/typesmith';

export const provideDb = (namespace: string) => {
  if (isOnServer()) {
    // Ignore server side persistance by default, avoid window related erros
    return new DumbDb();
  }

  const db = new PersistantDB(namespace);
  console.debug(
    `PersistantDB[${namespace}] initialized, will save selections in local storage`,
  );
  return db;
};

export interface IPersistantDB {
  get<T = string>(key: string): T | null;
  set<T = string>(key: string, value: T): void;
}

/**
 * Simple key-value database
 * Wrapper around local storge
 * Adds namespaces and JSON serialisation support
 */
export class PersistantDB implements IPersistantDB {
  constructor(public namespace = 'persistance') {}

  buildFullKey(key: string) {
    return `${this.namespace}/${key}`;
  }

  get<T = string>(key: string): T | null {
    const value = localStorage.getItem(this.buildFullKey(key));
    if (!value) {
      return value as null;
    }

    return JSON.parse(value) as T;
  }

  set<T = string>(key: string, value: T): void {
    const serialized: string =
      typeof value !== 'string' ? JSON.stringify(value) : value;

    localStorage.setItem(this.buildFullKey(key), serialized);
  }
}

/** Empty imlementation of PersistDB that can be used during pre-rendering step in server side */
export class DumbDb implements IPersistantDB {
  get(): null {
    return null;
  }

  set(): void {
    return;
  }
}
